module.exports = __webpack_public_path__ + "media/images/vehicles/vw_troc_suv-3cebaab22242baf3bb0c1791bd0d08ee.jpg";